
































import { Vue, Component, Prop } from "vue-property-decorator";
import { BInputGroup, BInputGroupAppend, BTooltip } from "bootstrap-vue";
import FlatPickr from "vue-flatpickr-component";
import { Russian } from "flatpickr/dist/l10n/ru.js";
import { FieldType } from "@lib";
import { Formatter } from "@/utils/formatter";
import { AltInputState } from ".";

@Component({
    name: "alt-date-time",
    components: { BInputGroup, BInputGroupAppend, BTooltip, FlatPickr },
})
export default class AltDateTime extends Vue {
    @Prop({ type: String })
    private id!: string;

    @Prop({ type: String })
    private label!: string;

    @Prop({ type: String })
    private placeholder!: string;

    @Prop({ type: String })
    private help!: string;

    @Prop({ type: Boolean })
    private disabled!: boolean;

    @Prop({ default: null })
    private state!: AltInputState | null;

    @Prop({ type: String })
    private subtext!: string;

    @Prop({ type: String })
    private subtextClass!: string;

    @Prop({ type: String })
    private value!: string;

    @Prop({ type: String, default: FieldType.DateTime })
    private mode!: FieldType.DateTime | FieldType.Date | FieldType.Time;

    // TODO: locale
    private getConfig() {
        // https://flatpickr.js.org/options/
        return {
            locale: Russian, //i18n.locale === "ru" ? Russian : null,
            enableTime: this.mode === FieldType.DateTime || this.mode === FieldType.Time,
            noCalendar: this.mode !== FieldType.DateTime && this.mode !== FieldType.Date,
            altInput: true,
            minuteIncrement: 1,
            //altFormat: "d.m.Y H:i",
            //dateFormat: "Z",
            //time_24hr: true,
            formatDate: (dt: Date) => Formatter.datetime(dt, { format: this.getDisplayFormat() }),
            onChange: this.onChange,
        };
    }

    private onChange(dates: Date[]): void {
        if (dates.length === 0) {
            return;
        }

        const value = Formatter.datetime(dates[0], { format: this.getOutputFormat() });
        this.$emit("input", value);
    }

    private getDisplayFormat(): string {
        if (this.mode === FieldType.Date) {
            return "L";
        }

        if (this.mode === FieldType.Time) {
            return "LT";
        }

        return "L LT";
    }

    private getOutputFormat(): string {
        return "YYYY-MM-DD HH:mm";
    }

    private get valueCurrent(): string {
        return this.value;
    }

    private set valueCurrent(value: string) {
        this.$emit("input", value);
    }

    private clearValue(): void {
        this.valueCurrent = "";
    }
}
